import { tt, LANGUAGE, LANGUAGE_FR } from "../../../../../../utils/i18n/i18n";
import { POSA_FORMAT } from "@tootsweet/model/lottery/POSAType";

const CLIENTS_PER_DAY_QUANTITIES_FLYERS: Record<string, number> = {
  less_than_50: 1500,
  "50_to_100": 2500,
  "100_to_200": 7500,
  more_than_200: 10000
};

const CLIENTS_PER_DAY_QUANTITIES_STICKERS: Record<string, number> = {
  less_than_50: 1500,
  "50_to_100": 3000,
  "100_to_200": 6000,
  more_than_200: 10000
};

const CLIENTS_PER_DAY_QUANTITIES_BUSINESS_CARDS: Record<string, number> = {
  less_than_50: 1500,
  "50_to_100": 3000,
  "100_to_200": 4000,
  more_than_200: 5000
};

function getQuantity(clientsPerDay: string, format: POSA_FORMAT): string {
  let res;
  switch (format) {
    case "stickers10x10":
      res = CLIENTS_PER_DAY_QUANTITIES_STICKERS[clientsPerDay];
      break;

    case "flyer_a6":
      res = CLIENTS_PER_DAY_QUANTITIES_FLYERS[clientsPerDay];
      break;

    case "businesscardsstandard":
      res = CLIENTS_PER_DAY_QUANTITIES_BUSINESS_CARDS[clientsPerDay];
      break;

    default:
      break;
  }

  if (res !== undefined) {
    const locale = LANGUAGE === LANGUAGE_FR ? "fr-FR" : "en-US";
    return new Intl.NumberFormat(locale).format(res);
  }

  return tt("posa_quantity_default");
}

export function getHandToHandDescription(
  clientsPerDay: string,
  format: POSA_FORMAT
): string {
  return tt("posa_form_preview_hand_to_hand_description", {
    quantity: getQuantity(clientsPerDay, format)
  });
}

export function getTableSupportDescription(
  supportFormat: string,
  quantity: string | number
): string {
  switch (supportFormat) {
    case "flyer_a5":
      return tt("posa_form_preview_table_presence_flyer_a5", { quantity });
    case "flyer_a6":
      return tt("posa_form_preview_table_presence_flyer_a6", { quantity });
    case "stickers_dome":
      return tt("posa_form_preview_table_presence_stickers_dome", { quantity });
    default:
      return "";
  }
}

export function getDeliveryBagDescription(
  supportFormat: POSA_FORMAT | "none",
  clientsPerDay: string
): string {
  switch (supportFormat) {
    case "flyer_a6":
      return tt("posa_form_preview_delivery_bag_flyer_a6", {
        quantity: getQuantity(clientsPerDay, supportFormat)
      });
    case "stickers10x10":
      return tt("posa_form_preview_delivery_bag_stickers10x10", {
        quantity: getQuantity(clientsPerDay, supportFormat)
      });
    case "businesscardsstandard":
      return tt("posa_form_preview_hand_to_hand_description", {
        quantity: getQuantity(clientsPerDay, supportFormat)
      });
    default:
      return "";
  }
}
